import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { PageLoader } from '..';

const PreviewDocsModal = ({ previewDocs, toggleModalFn }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isDownloading, setIsDownloading] = useState(false);
    const ext = previewDocs?.extension?.toLowerCase();

    const onDownload = () => {
        setIsDownloading(true);
        axios.get(previewDocs?.url, { responseType: 'arraybuffer' })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', previewDocs?.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setIsDownloading(false);
            })
            .catch(() => {
                enqueueSnackbar('Download failed. Please try again.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                setIsDownloading(false);
            });
    };

    const searchTerm = new URLSearchParams(window.location.search).get('searchTerm') || '';

    return (
        <>
            <Dialog open={true} fullScreen>
                <DialogTitle sx={{ backgroundColor: '#c0c6df', padding: '5px 0px 5px 22px' }}>
                    <Box display="flex" alignItems="center">
                        <Typography sx={{ flexGrow: 1 }} variant="h6">
                            {previewDocs?.name}
                        </Typography>
                        <IconButton color="inherit" onClick={toggleModalFn} sx={{ mr: 1 }}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column' }} dividers>
                    {ext === 'csv' ? (
                        <object
                            data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/xls_viewer/index.html?file=${encodeURIComponent(previewDocs?.url)}`}
                            style={{ width: '100%', height: window.innerHeight - 100 }}
                        />
                    ) : ['xls', 'xlsx', 'docx'].includes(ext) ? (
                        <iframe
                            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewDocs?.url)}`}
                            width="100%"
                            height={window.innerHeight}
                            frameBorder="0"
                            title={previewDocs?.name}
                        />
                    ) : ['jpg', 'jpeg', 'png'].includes(ext) ? (
                        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#edebeb', p: 2 }}>
                            <img
                                src={previewDocs?.url}
                                alt={previewDocs?.name}
                                style={{ maxWidth: '95%', maxHeight: '95%', objectFit: 'inherit' }}
                            />
                        </Box>
                    ) : ext === 'pdf' ? (
                        <object
                            type="text/html"
                            data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/pdf.js/web/viewer.html?file=${encodeURIComponent(previewDocs?.url)}#search=${searchTerm}`}
                            style={{ width: '100%', height: window.innerHeight - 100 }}
                        >
                            <param name="type" value="text/html" />
                        </object>
                    ) : null}
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" size="small" color="primary" disabled={isDownloading} onClick={onDownload}>
                        {isDownloading ? 'Downloading...' : 'Download'}
                    </Button>
                    <Button variant="outlined" size="small" color="primary" onClick={toggleModalFn}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {isDownloading ? <PageLoader /> : null}
        </>
    );
};

export default PreviewDocsModal;
